import { render, staticRenderFns } from "./menu-normal-view.vue?vue&type=template&id=2230177e"
import script from "./menu-normal-view.vue?vue&type=script&lang=js"
export * from "./menu-normal-view.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {MenuGroupBy: require('/home/runner/work/foaps-v2/foaps-v2/components/menu/menu-group-by.vue').default,MenuComboList: require('/home/runner/work/foaps-v2/foaps-v2/components/menu/menu-combo-list.vue').default,MenuHeaderSearchField: require('/home/runner/work/foaps-v2/foaps-v2/components/menu/menu-header-search-field.vue').default,MenuNormalList: require('/home/runner/work/foaps-v2/foaps-v2/components/menu/menu-normal-list.vue').default,MenuItemToggleRequest: require('/home/runner/work/foaps-v2/foaps-v2/components/menu/menu-item-toggle-request.vue').default,MenuItemModificationRequest: require('/home/runner/work/foaps-v2/foaps-v2/components/menu/menu-item-modification-request.vue').default,MenuSoldOutList: require('/home/runner/work/foaps-v2/foaps-v2/components/menu/menu-sold-out-list.vue').default})
